import { render, staticRenderFns } from "./DeclineInterview.vue?vue&type=template&id=5c2bf6b4&scoped=true"
import script from "./DeclineInterview.vue?vue&type=script&lang=js"
export * from "./DeclineInterview.vue?vue&type=script&lang=js"
import style0 from "./DeclineInterview.vue?vue&type=style&index=0&id=5c2bf6b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2bf6b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c2bf6b4')) {
      api.createRecord('5c2bf6b4', component.options)
    } else {
      api.reload('5c2bf6b4', component.options)
    }
    module.hot.accept("./DeclineInterview.vue?vue&type=template&id=5c2bf6b4&scoped=true", function () {
      api.rerender('5c2bf6b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/RecruitManage/RecruitStatus/DeclineInterview.vue"
export default component.exports